import '../style/Profile.css';
import Login from './Login';

const Profile = (props: { isLoggedIn: boolean }) => {
  return (
    <>
      <meta name='robots' content='noindex' />
      <title>REM Profile</title>

      {props.isLoggedIn ? (
        <div className='profile-container'>
          <h1>Your Profile</h1>
          <p>Welcome back! Here is your profile information.</p>
        </div>
      ) : (
        <Login />
      )}
    </>
  );
};

export default Profile;
